<div class="useful-resources">
    <h2 class="webapp-title-secondary">{{cardInfo.title}}</h2>
    <div class="resource-card" *ngFor="let resource of cardInfo.array">
      <mat-icon>{{ resource.icon }}</mat-icon>
      <h4 (click)="onCtaClick()">{{ resource.title }}</h4>
      <p>{{ resource.description }}</p>
    </div>
</div>